'use client';

var _excluded = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "id", "loading", "loadingIndicator", "loadingPosition", "size", "startIcon", "type", "variant"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import clsx from 'clsx';
import resolveProps from '@mui/utils/resolveProps';
import composeClasses from '@mui/utils/composeClasses';
import { alpha } from '@mui/system/colorManipulator';
import { unstable_useId as useId } from '@mui/material/utils';
import rootShouldForwardProp from "../styles/rootShouldForwardProp.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import ButtonBase from "../ButtonBase/index.js";
import CircularProgress from "../CircularProgress/index.js";
import capitalize from "../utils/capitalize.js";
import createSimplePaletteValueFilter from "../utils/createSimplePaletteValueFilter.js";
import buttonClasses, { getButtonUtilityClass } from "./buttonClasses.js";
import ButtonGroupContext from "../ButtonGroup/ButtonGroupContext.js";
import ButtonGroupButtonContext from "../ButtonGroup/ButtonGroupButtonContext.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var color = ownerState.color,
    disableElevation = ownerState.disableElevation,
    fullWidth = ownerState.fullWidth,
    size = ownerState.size,
    variant = ownerState.variant,
    loading = ownerState.loading,
    loadingPosition = ownerState.loadingPosition,
    classes = ownerState.classes;
  var slots = {
    root: ['root', loading && 'loading', variant, "".concat(variant).concat(capitalize(color)), "size".concat(capitalize(size)), "".concat(variant, "Size").concat(capitalize(size)), "color".concat(capitalize(color)), disableElevation && 'disableElevation', fullWidth && 'fullWidth', loading && "loadingPosition".concat(capitalize(loadingPosition))],
    startIcon: ['icon', 'startIcon', "iconSize".concat(capitalize(size))],
    endIcon: ['icon', 'endIcon', "iconSize".concat(capitalize(size))],
    loadingIndicator: ['loadingIndicator'],
    loadingWrapper: ['loadingWrapper']
  };
  var composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
  return _objectSpread(_objectSpread({}, classes), composedClasses);
};
var commonIconStyles = [{
  props: {
    size: 'small'
  },
  style: {
    '& > *:nth-of-type(1)': {
      fontSize: 18
    }
  }
}, {
  props: {
    size: 'medium'
  },
  style: {
    '& > *:nth-of-type(1)': {
      fontSize: 20
    }
  }
}, {
  props: {
    size: 'large'
  },
  style: {
    '& > *:nth-of-type(1)': {
      fontSize: 22
    }
  }
}];
var ButtonRoot = styled(ButtonBase, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return rootShouldForwardProp(prop) || prop === 'classes';
  },
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, styles[ownerState.variant], styles["".concat(ownerState.variant).concat(capitalize(ownerState.color))], styles["size".concat(capitalize(ownerState.size))], styles["".concat(ownerState.variant, "Size").concat(capitalize(ownerState.size))], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth, ownerState.loading && styles.loading];
  }
})(memoTheme(function (_ref) {
  var theme = _ref.theme;
  var inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
  var inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
  return _objectSpread(_objectSpread({}, theme.typography.button), {}, _defineProperty(_defineProperty({
    minWidth: 64,
    padding: '6px 16px',
    border: 0,
    borderRadius: (theme.vars || theme).shape.borderRadius,
    transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
      duration: theme.transitions.duration.short
    }),
    '&:hover': {
      textDecoration: 'none'
    }
  }, "&.".concat(buttonClasses.disabled), {
    color: (theme.vars || theme).palette.action.disabled
  }), "variants", [{
    props: {
      variant: 'contained'
    },
    style: _defineProperty(_defineProperty({
      color: "var(--variant-containedColor)",
      backgroundColor: "var(--variant-containedBg)",
      boxShadow: (theme.vars || theme).shadows[2],
      '&:hover': {
        boxShadow: (theme.vars || theme).shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: (theme.vars || theme).shadows[2]
        }
      },
      '&:active': {
        boxShadow: (theme.vars || theme).shadows[8]
      }
    }, "&.".concat(buttonClasses.focusVisible), {
      boxShadow: (theme.vars || theme).shadows[6]
    }), "&.".concat(buttonClasses.disabled), {
      color: (theme.vars || theme).palette.action.disabled,
      boxShadow: (theme.vars || theme).shadows[0],
      backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    })
  }, {
    props: {
      variant: 'outlined'
    },
    style: _defineProperty({
      padding: '5px 15px',
      border: '1px solid currentColor',
      borderColor: "var(--variant-outlinedBorder, currentColor)",
      backgroundColor: "var(--variant-outlinedBg)",
      color: "var(--variant-outlinedColor)"
    }, "&.".concat(buttonClasses.disabled), {
      border: "1px solid ".concat((theme.vars || theme).palette.action.disabledBackground)
    })
  }, {
    props: {
      variant: 'text'
    },
    style: {
      padding: '6px 8px',
      color: "var(--variant-textColor)",
      backgroundColor: "var(--variant-textBg)"
    }
  }].concat(_toConsumableArray(Object.entries(theme.palette).filter(createSimplePaletteValueFilter()).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 1),
      color = _ref3[0];
    return {
      props: {
        color: color
      },
      style: {
        '--variant-textColor': (theme.vars || theme).palette[color].main,
        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
        '--variant-outlinedBorder': theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / 0.5)") : alpha(theme.palette[color].main, 0.5),
        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
        '--variant-containedBg': (theme.vars || theme).palette[color].main,
        '@media (hover: hover)': {
          '&:hover': {
            '--variant-containedBg': (theme.vars || theme).palette[color].dark,
            '--variant-textBg': theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette[color].main, theme.palette.action.hoverOpacity),
            '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
            '--variant-outlinedBg': theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette[color].main, theme.palette.action.hoverOpacity)
          }
        }
      }
    };
  })), [{
    props: {
      color: 'inherit'
    },
    style: {
      color: 'inherit',
      borderColor: 'currentColor',
      '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
      '@media (hover: hover)': {
        '&:hover': {
          '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
          '--variant-textBg': theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity),
          '--variant-outlinedBg': theme.vars ? "rgba(".concat(theme.vars.palette.text.primaryChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity)
        }
      }
    }
  }, {
    props: {
      size: 'small',
      variant: 'text'
    },
    style: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    }
  }, {
    props: {
      size: 'large',
      variant: 'text'
    },
    style: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    }
  }, {
    props: {
      size: 'small',
      variant: 'outlined'
    },
    style: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    }
  }, {
    props: {
      size: 'large',
      variant: 'outlined'
    },
    style: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    }
  }, {
    props: {
      size: 'small',
      variant: 'contained'
    },
    style: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    }
  }, {
    props: {
      size: 'large',
      variant: 'contained'
    },
    style: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    }
  }, {
    props: {
      disableElevation: true
    },
    style: _defineProperty(_defineProperty(_defineProperty({
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      }
    }, "&.".concat(buttonClasses.focusVisible), {
      boxShadow: 'none'
    }), '&:active', {
      boxShadow: 'none'
    }), "&.".concat(buttonClasses.disabled), {
      boxShadow: 'none'
    })
  }, {
    props: {
      fullWidth: true
    },
    style: {
      width: '100%'
    }
  }, {
    props: {
      loadingPosition: 'center'
    },
    style: _defineProperty({
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
        duration: theme.transitions.duration.short
      })
    }, "&.".concat(buttonClasses.loading), {
      color: 'transparent'
    })
  }])));
}));
var ButtonStartIcon = styled('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.startIcon, ownerState.loading && styles.startIconLoadingStart, styles["iconSize".concat(capitalize(ownerState.size))]];
  }
})(function (_ref4) {
  var theme = _ref4.theme;
  return {
    display: 'inherit',
    marginRight: 8,
    marginLeft: -4,
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        marginLeft: -2
      }
    }, {
      props: {
        loadingPosition: 'start',
        loading: true
      },
      style: {
        transition: theme.transitions.create(['opacity'], {
          duration: theme.transitions.duration.short
        }),
        opacity: 0
      }
    }, {
      props: {
        loadingPosition: 'start',
        loading: true,
        fullWidth: true
      },
      style: {
        marginRight: -8
      }
    }].concat(commonIconStyles)
  };
});
var ButtonEndIcon = styled('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.endIcon, ownerState.loading && styles.endIconLoadingEnd, styles["iconSize".concat(capitalize(ownerState.size))]];
  }
})(function (_ref5) {
  var theme = _ref5.theme;
  return {
    display: 'inherit',
    marginRight: -4,
    marginLeft: 8,
    variants: [{
      props: {
        size: 'small'
      },
      style: {
        marginRight: -2
      }
    }, {
      props: {
        loadingPosition: 'end',
        loading: true
      },
      style: {
        transition: theme.transitions.create(['opacity'], {
          duration: theme.transitions.duration.short
        }),
        opacity: 0
      }
    }, {
      props: {
        loadingPosition: 'end',
        loading: true,
        fullWidth: true
      },
      style: {
        marginLeft: -8
      }
    }].concat(commonIconStyles)
  };
});
var ButtonLoadingIndicator = styled('span', {
  name: 'MuiButton',
  slot: 'LoadingIndicator',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.loadingIndicator;
  }
})(function (_ref6) {
  var theme = _ref6.theme;
  return {
    display: 'none',
    position: 'absolute',
    visibility: 'visible',
    variants: [{
      props: {
        loading: true
      },
      style: {
        display: 'flex'
      }
    }, {
      props: {
        loadingPosition: 'start'
      },
      style: {
        left: 14
      }
    }, {
      props: {
        loadingPosition: 'start',
        size: 'small'
      },
      style: {
        left: 10
      }
    }, {
      props: {
        variant: 'text',
        loadingPosition: 'start'
      },
      style: {
        left: 6
      }
    }, {
      props: {
        loadingPosition: 'center'
      },
      style: {
        left: '50%',
        transform: 'translate(-50%)',
        color: (theme.vars || theme).palette.action.disabled
      }
    }, {
      props: {
        loadingPosition: 'end'
      },
      style: {
        right: 14
      }
    }, {
      props: {
        loadingPosition: 'end',
        size: 'small'
      },
      style: {
        right: 10
      }
    }, {
      props: {
        variant: 'text',
        loadingPosition: 'end'
      },
      style: {
        right: 6
      }
    }, {
      props: {
        loadingPosition: 'start',
        fullWidth: true
      },
      style: {
        position: 'relative',
        left: -10
      }
    }, {
      props: {
        loadingPosition: 'end',
        fullWidth: true
      },
      style: {
        position: 'relative',
        right: -10
      }
    }]
  };
});
var ButtonLoadingIconPlaceholder = styled('span', {
  name: 'MuiButton',
  slot: 'LoadingIconPlaceholder',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.loadingIconPlaceholder;
  }
})({
  display: 'inline-block',
  width: '1em',
  height: '1em'
});
var Button = /*#__PURE__*/React.forwardRef(function Button(inProps, ref) {
  // props priority: `inProps` > `contextProps` > `themeDefaultProps`
  var contextProps = React.useContext(ButtonGroupContext);
  var buttonGroupButtonContextPositionClassName = React.useContext(ButtonGroupButtonContext);
  var resolvedProps = resolveProps(contextProps, inProps);
  var props = useDefaultProps({
    props: resolvedProps,
    name: 'MuiButton'
  });
  var children = props.children,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    _props$component = props.component,
    component = _props$component === void 0 ? 'button' : _props$component,
    className = props.className,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$disableElevati = props.disableElevation,
    disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
    _props$disableFocusRi = props.disableFocusRipple,
    disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
    endIconProp = props.endIcon,
    focusVisibleClassName = props.focusVisibleClassName,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    idProp = props.id,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? null : _props$loading,
    loadingIndicatorProp = props.loadingIndicator,
    _props$loadingPositio = props.loadingPosition,
    loadingPosition = _props$loadingPositio === void 0 ? 'center' : _props$loadingPositio,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    startIconProp = props.startIcon,
    type = props.type,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'text' : _props$variant,
    other = _objectWithoutProperties(props, _excluded);
  var loadingId = useId(idProp);
  var loadingIndicator = loadingIndicatorProp !== null && loadingIndicatorProp !== void 0 ? loadingIndicatorProp : /*#__PURE__*/_jsx(CircularProgress, {
    "aria-labelledby": loadingId,
    color: "inherit",
    size: 16
  });
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    color: color,
    component: component,
    disabled: disabled,
    disableElevation: disableElevation,
    disableFocusRipple: disableFocusRipple,
    fullWidth: fullWidth,
    loading: loading,
    loadingIndicator: loadingIndicator,
    loadingPosition: loadingPosition,
    size: size,
    type: type,
    variant: variant
  });
  var classes = useUtilityClasses(ownerState);
  var startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/_jsx(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp || /*#__PURE__*/_jsx(ButtonLoadingIconPlaceholder, {
      className: classes.loadingIconPlaceholder,
      ownerState: ownerState
    })
  });
  var endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/_jsx(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp || /*#__PURE__*/_jsx(ButtonLoadingIconPlaceholder, {
      className: classes.loadingIconPlaceholder,
      ownerState: ownerState
    })
  });
  var positionClassName = buttonGroupButtonContextPositionClassName || '';
  var loader = typeof loading === 'boolean' ? /*#__PURE__*/
  // use plain HTML span to minimize the runtime overhead
  _jsx("span", {
    className: classes.loadingWrapper,
    style: {
      display: 'contents'
    },
    children: loading && /*#__PURE__*/_jsx(ButtonLoadingIndicator, {
      className: classes.loadingIndicator,
      ownerState: ownerState,
      children: loadingIndicator
    })
  }) : null;
  return /*#__PURE__*/_jsxs(ButtonRoot, _objectSpread(_objectSpread({
    ownerState: ownerState,
    className: clsx(contextProps.className, classes.root, className, positionClassName),
    component: component,
    disabled: disabled || loading,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type,
    id: loading ? loadingId : idProp
  }, other), {}, {
    classes: classes,
    children: [startIcon, loadingPosition !== 'end' && loader, children, loadingPosition === 'end' && loader, endIcon]
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Button;